<template>
  <span
    class="c-tooltip"
    :class="isArrowLeft ? 'c-tooltip--left' : ''">
    {{text}}
  </span>
</template>

<script>
export default {
  name: 'Tooltip',

  props: {
    text: {
      type: String,
      default: ''
    },
    isArrowLeft: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/scss/_vars.scss';

.c-tooltip {
  display: none;
  position: absolute;
  color: $white;
  font-size: 14px;
  line-height: 30px;
  padding: 0 16px;
  background-color: $blue;
  border-radius: 3px 0 0 3px;
  right: 60px;
  top: 5px;
  width: auto;
  white-space: nowrap;

  &::after {
    display: none;
    position: absolute;
    display: block;
    content:'';
    width: 0px;
    height: 0px;
    border-top: 15px solid transparent;
    border-bottom: 16px solid transparent;
    border-left: 16px solid $blue;
    right: -15px;
    top: 0;
  }
}

.c-tooltip--left {
  left: 130px;
  top: 29px;
  right: auto;

  &::after {
    display: none;
  }

  &::before {
    display: none;
    position: absolute;
    display: block;
    content:'';
    width: 0px;
    height: 0px;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-right: 16px solid $blue;
    left: -15px;
    top: 0;
  }
}
</style>
